import create from './createJsonStorage.js';
export default create(localStorage);
//# sourceMappingURL=localStorageJson.js.map